import { render, staticRenderFns } from "./mags.vue?vue&type=template&id=02e81dc2&"
import script from "./mags.vue?vue&type=script&lang=js&"
export * from "./mags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports